import React, { CSSProperties, FC } from 'react';

type BgColorProps = {
	color?: string;
	className?: string;
	style?: CSSProperties;
};

export const BgColor: FC<React.PropsWithChildren<BgColorProps>> = ({ children, color, className, style }) => {
	return (
		<div
			className={className}
			style={{ backgroundColor: color, ...style }}
		>
			{children}
		</div>
	);
};
